<cerrix-dialog [name]="name" [attr.data-uiid]="dataUiid">
    <div header-title>
        <span> {{ title }} </span>
    </div>
    <div class="textarea-dialog-content" dialog-content>
        <cerrix-textarea
            [name]="name + '-textarea'"
            [readOnly]="readOnly"
            [rows]="14"
            [(value)]="value"
            [attr.data-uiid]="dataUiid + '--textarea'"
        ></cerrix-textarea>
    </div>
    <div class="textarea-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            (click)="cancel.emit()"
            [attr.data-uiid]="dataUiid + '--cancel'"
            >{{ readOnly ? "Close" : "Cancel" }}</cerrix-button
        >
        @if (!readOnly) {
            <cerrix-button
                buttonSize="big"
                (click)="onConfirm()"
                [attr.data-uiid]="dataUiid + '--update-changes'"
            >
                Update changes</cerrix-button
            >
        }
    </div>
</cerrix-dialog>
